<template>
  <div class="il-screen">

    <!-- HEADER CARD: point number + instructions -->
    <div class="il-header-card">
      <div class="il-header-top">
        <p class="il-point-label">{{ translation.pointNumber }}</p>
      </div>
      <div class="il-point-circle" style="cursor:pointer" @click="$parent.slideMapInn()">
        {{ Object.values(points)[pointsArrayOrder[$parent.pointNum] - 1].pointNumber }}
      </div>
      <div class="il-instructions">
        <p v-if="translation.goThere" class="il-go-there">{{ translation.goThere }}</p>
        <p v-if="translation.whatCanBeSeen" class="il-what-seen">{{ translation.whatCanBeSeen }}</p>
        <p v-if="translation.explaination" class="il-explaination">{{ translation.explaination }}</p>
      </div>
    </div>

    <!-- IMAGE CARDS LIST -->
    <div class="il-images-list">
      <div v-for="(item, index) in arrayOfImages" :key="index" class="il-image-card imageDiv">
        <img :src="item" alt="" class="il-image" @click="checkAnswer(index, $event)" />
      </div>
    </div>

  </div>
</template>


<script>
export default {
  data() {
    return {
      activeClass: "activePoint",
      notActive: "smallPoint",
      activeClassPoint: "activeClassPoint",
      notActivePoint: "numbersInCercle",
      slide: 0,
      sliding: null,
      key: "",
      translation: "",
      correctAnswerSound: require("../../static/sounds/correctAnswer.mp3"),
      wongAnswerSound: require("../../static/sounds/wrongAnswer.mp3"),
      // Shuffle done once in mounted — stable for the lifetime of this screen
      arrayOfImages: [],
      correctIndex: -1,
    };
  },
  mounted() {
    // Build the shuffled list and record the correct index ONCE
    const raw = (() => {
      // Prefer the in-memory store: it's always rebuilt fresh by fetchGameData/fetchPoints.
      // Only fall back to localStorage if the store is empty (e.g. SSR or cold start).
      const storeImgs = this.$store.getters.arrayOfImagesBase64;
      if (storeImgs && storeImgs.length > 0) return storeImgs;
      try {
        const ls = localStorage.getItem("arrayOfImagesBase64");
        if (ls) return JSON.parse(ls);
      } catch (e) { /* ignore */ }
      return [];
    })();

    const allPoints = this.$store.getters.points;
    const pointsArr = Array.isArray(allPoints) ? allPoints : Object.values(allPoints || {});

    // Exclude images from points that use missingWord as their navigation screen
    // (those images are reserved as missingWord clues)
    const filtered = raw.filter((img, i) => {
      if (!img || (!img.startsWith('data:') && !img.startsWith('http'))) return false;
      const pt = pointsArr[i];
      return !pt || pt.navigationScreen !== 'missingWord';
    });

    // Shuffle
    const shuffled = [...filtered];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }

    // Find the correct image by POSITION in the points array.
    // play.vue overwrites state.points with lean data (no imageBase64),
    // so we cannot rely on currentPoint.imageBase64. Instead we use the index:
    // raw[i] was built from points[i], so they share the same order.
    const currentPointNumber = (() => {
      const order = localStorage.getItem("pointsArrayOrder")
        ? JSON.parse(localStorage.getItem("pointsArrayOrder"))
        : this.$store.getters.pointsArrayOrder;
      return order[this.$parent.pointNum];
    })();
    const pointIdx = pointsArr.findIndex(p => String(p.pointNumber) === String(currentPointNumber));

    // raw[pointIdx] is exactly what was stored in arrayOfImagesBase64 for this point
    const correctImg = pointIdx >= 0 ? (raw[pointIdx] || '') : '';

    this.arrayOfImages = shuffled;
    this.correctIndex = shuffled.indexOf(correctImg);
    // Translate after arrayOfImages is set so the count is correct
    this.translate(this.$store.getters.lang);
  },
  computed: {
    lang() {
      return this.translate(this.$store.getters.lang);
    },

    gameParameters() {
      return this.$store.getters.gameParameters;
    },
    pointsArrayOrder() {
      if (localStorage.getItem("pointsArrayOrder")) {
        return JSON.parse(localStorage.getItem("pointsArrayOrder"));
      } else {
        return this.$store.getters.pointsArrayOrder;
      }
    },
    points() {
      return this.$store.getters.points;
    },
  },

  methods: {
    checkAnswer(index, event) {
      if (index === this.correctIndex) {
        event.target.parentElement.classList.add("greenBorder");
        this.$parent.errorNumber = this.$parent.errorNumber + 5;
        this.$parent.showStarUp("5+");
        this.$parent.showCorrectAnswerIcon = true;
        var audio = new Audio(this.correctAnswerSound);
        audio.play();
        this.$parent.checkElementPicked();
        localStorage.setItem("errorNumber", this.$parent.errorNumber);
        setTimeout(() => {
          this.$parent.showCorrectAnswerIcon = false;
          window.scrollTo(0, 0);
          this.$parent.afterNavigationComplete();
        }, 1000);

        // REPONSE EST FAUSSE
      } else {
        event.target.parentElement.classList.add("redBorder");
        this.$parent.errorNumber = this.$parent.errorNumber - 1;
        this.$parent.$refs.pointsCounting.classList.add("redColor");
        localStorage.setItem("errorNumber", this.$parent.errorNumber);
        this.$parent.showWongAnswerIcon = true;

        audio = new Audio(this.wongAnswerSound);
        audio.play();

        setTimeout(() => {
          console.log("b4 remove redborder");
          event.target.parentElement.classList.remove("redBorder");
          // this.$refs.checkAnswerButton.classList.remove("redBorder");
          this.$parent.$refs.pointsCounting.classList.remove("redColor");
          this.$parent.showWongAnswerIcon = false;
        }, 1000);
      }
    },
    translate(lang) {
      switch (lang) {
        case "ar":
          this.translation = {
            whatCanBeSeen: "ماذا ممكن أن نرى بالمكان؟",
            explaination:
              "اختاروا الصورة المناسبة من بين " +
              this.arrayOfImages.length +
              " صورة التالية ",
            clickToResults: "انقر للحصول على النتائج",
            runningTime: "الوقت المنقضي",
            goToFirstPoint: "الوصول إلى النقطة الموضحة على الخريطة",
            followThePath: "اتبع الطريق الموضح على الخريطة",
            clickTheBuzzer: "انقر فوق الجرس",
            back: "اغلاق",
            skipPoint: "الانتقال الى النقطة القادمة",
            skipPointBeware:
              "انتبهوا!  إذا لم تتمكنوا من العثور على المحطة، يمكنكم الانتقال إلى المحطة التالية، لكنكم ستخسرون 10 نقاط",
            mistakes: " الأخطاء ",
            runTime: "وقت التشغيل",
            pointsScore: "النقاط ",
            map: " الخارطة",
            pointNumber: "جدوا رقم المحطة على الخريطة",
            goThere: "الوصول إلى المحطة",
            didYouKnow: "هل تعلم؟",
            goToQuestions: "استمر",
            wellDone: "جميل جدًا!",
            correctAnswer: "لقد أتيت إلى المكان الصحيح",
            continue: "انقر للمتابعة",
            wrongAnswer: "إجابة غير صحيحة.",
            tryAgain: " لنحاول مرة أخرى!",
            visitOf: "أتمنى أن تكون قد استمتعت باللعبة",
            yourResults: " نتائجك: ",
            errorNumber: "النقاط:",
            goToRanking: "قبل أن تنتهي , يمكنك معرفة المركز الذي أنت فيه!",
            checkLocation: "وصلت!",
            evolution: "تقدم",
            timeOver: "انتهى الوقت - انتقل إلى النقطة التالية",
            locationVerification: "التحقق من الموقع",
            results: "النتائج",
            first: "",
            afterFirst: "",
            errors: "النقاط",
            gameTime: "وقت اللعب",
            totalTime: "إجمالي الوقت",
            leaveEmail:
              "إذا استمتعت , اترك لنا عنوان بريدك الإلكتروني وسنخطرك عند فتح طرق جديدة.",
            backToHomePage: "الصفحة الرئيسية",
            backToResults: "إلى النتائج",
            openWhatsApp: "دافق",
            firstPlace: "المركز الأول",
            rank: "المركز",
            howWasIt: "كيف كان ذلك بالنسبة لك؟",
            noThanks: "لا شكرًا",
            send: "إرسال",
            share: " شارك",
            stamp: "عين دور",
            beware: "انتبه!",
            goToStartPointWaze: "الوصول إلى نقطة البداية",
            startPoint: "تبدأ اللعبة عند مفرق التوسيع",
            LetsGoButton: "ابدأ!",
            beforeStarting: "قبل البدء, شاهد كيف يعمل",
            ok: " بالتأكيد!",
            skip: "لا, شكرًا",
            noPassword: "يبدو أنك نسيت إدخال اسمك",
            gotIt: "حسنًا",
            oups: "للاسف",
            finishedTheGame: "لقد انتهيت من اللعبة، عدد النقاط: ",
          };
          break;
        case "en":
          this.translation = {
            goThere: "Go there, and find this inscription ",
          };

          // code block
          break;
        case "he":
          this.translation = {
            checkAnswer: "בדיקה",
            whatCanBeSeen: "מה ניתן לראות במקום?",
            imageNumber: "תמונה מספר ",
            chooseImageSeen: "מכאן, רואים את המראה בתמונה מלעה.",
            pointNumber: "מצאו במפה את תחנה מספר",
            goThere: "הגיעו לתחנה.",
            explaination:
              "בחרו את התמונה הנכונה בין " +
              this.arrayOfImages.length +
              " התמונות הבאות",
          };
          // code block
          break;
        default:
        // code block
      }
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
};
</script>

<style scoped>
/* ── Root container ─────────────────────────────────────── */
.il-screen {
  font-family: VarelaRound, sans-serif;
  color: white;
  min-height: 100vh;
  padding: 24px 16px 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  width: 100%;
  max-width: 590px;
  margin: 0 auto;
  box-sizing: border-box;
}

/* ── Header card ────────────────────────────────────────── */
.il-header-card {
  /* background: rgba(0, 0, 0, 0.45); */
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  padding: 20px 24px;
  text-align: center;
  width: 100%;
  max-width: 480px;
}

.il-header-top {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 10px;
}

.il-header-emoji {
  font-size: 26px;
  line-height: 1;
}

.il-point-label {
  margin: 0;
  font-size: 18px;
  opacity: 0.85;
  letter-spacing: 0.3px;
}

.il-point-circle {
  margin: 0 auto 14px;
  width: 62px;
  height: 62px;
  border-radius: 50%;
  border: 3px solid #0090e3;
  background: rgba(0, 144, 227, 0.15);
  font-size: 32px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.il-instructions {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.il-go-there {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
}

.il-what-seen {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  opacity: 0.9;
}

.il-explaination {
  margin: 0;
  font-size: 15px;
  opacity: 0.8;
  line-height: 1.4;
}

/* ── Images list ────────────────────────────────────────── */
.il-images-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 480px;
}

/* imageDiv is kept as the class name because JS adds greenBorder/redBorder
   to event.target.parentElement which will be this element */
.il-image-card {
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
  transition: border-color 0.2s, box-shadow 0.2s;
  cursor: pointer;
}

.il-image-card:hover {
  border-color: rgba(0, 144, 227, 0.5);
  box-shadow: 0 6px 24px rgba(0, 144, 227, 0.2);
}

.il-image {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 0;
}

/* ── Answer feedback borders (applied by JS to .imageDiv = .il-image-card) */
.greenBorder {
  border: 4px solid rgb(5, 253, 5) !important;
  box-shadow: 0 0 20px rgba(5, 253, 5, 0.4) !important;
}

.redBorder {
  border: 4px solid rgb(253, 5, 5) !important;
  box-shadow: 0 0 20px rgba(253, 5, 5, 0.4) !important;
}

</style>
